import React from 'react';
import { useDispatch } from 'react-redux';

import ProductCardQuickShopLink from 'components/common/ProductCardQuickShopLink';
import MicrosoftAdsCarousel from 'components/search/MicrosoftAdsCarousel';
import { Product } from 'constants/searchTypes';
import { track } from 'apis/amethyst';
import { evRecommendationClick } from 'events/recommendations';
import { useSponsoredAds } from 'hooks/useSponsoredAds';
import { trackMicrosoftAdImpressions } from 'actions/products';

export interface OwnProps {
  stockId: string;
  keywords: string[];
  containerClassName: string;
  isFullMaxWidth?: boolean;
  isHydraMobileTwoRecos?: boolean;
}

const PdpSponsoredAds = ({
  stockId,
  keywords,
  containerClassName,
  isFullMaxWidth = false,
  isHydraMobileTwoRecos = false
}: OwnProps): React.ReactElement => {
  const dispatch = useDispatch();

  const sponsoredAds = useSponsoredAds({ stockId, keywords, pageType: 'Product' });

  const makeTrackMicrosoftAdClick = (product: Pick<Product, 'productId' | 'styleId' | 'colorId'>, index: number) => {
    const { productId, styleId, colorId } = product;
    return () => {
      track(() => [
        evRecommendationClick,
        {
          index,
          recommendationType: 'PRODUCT_RECOMMENDATION',
          productIdentifiers: {
            productId,
            styleId,
            colorId
          },
          recommendationSource: 'MICROSOFT',
          widgetType: 'MICROSOFT_TOP_BLOCK',
          sourcePage: 'PRODUCT_PAGE'
        }
      ]);
    };
  };

  return (
    <MicrosoftAdsCarousel
      containerClassName={containerClassName}
      msftResults={sponsoredAds}
      trackMicrosoftAdImpressions={({ url }: { url: string }) => dispatch(trackMicrosoftAdImpressions({ url }))}
      makeMicrosoftAdClick={makeTrackMicrosoftAdClick}
      CardBottomSlot={ProductCardQuickShopLink}
      isFullMaxWidth={isFullMaxWidth}
      isHydraMobileTwoRecos={isHydraMobileTwoRecos}
    />
  );
};

export default PdpSponsoredAds;
